/* eslint-disable*/
const filterEnumSubAreas = async (params, selected) => {
  let array = [];
  const csv = [];
  array = params.filter((res) => {
    const isDuplicate = csv.includes(res.subArea.csv);

    if (!isDuplicate && res.area.csv == selected.csv) {
      csv.push(res.subArea.csv);

      return true;
    }

    return false;
  });
  return array.map((res) => {
    return { label: res.subArea.text, value: res.subArea.csv };
  });
};

export { filterEnumSubAreas };
